/**
 *  Parse a row from the ELIG3 type files
 *  ELIG3 files contain patient information and eligibility dates.
 */
let dayjs = require('dayjs').default
if (!dayjs) dayjs = require('dayjs')
const { parseDate, makeDate } = require('../fileDates')

const DEFAULT_MAP = {
  carrier: [0, 9],
  account: [9, 24],
  group: [24, 39],
  memberId: [39, 57],
  personCode: [57, 60],
  relationship: [60, 61],
  lastName: [61, 86],
  firstName: [86, 101],
  middleInitial: [101, 102],
  sexCode: [102, 103],
  dateOfBirth: [103, 111, 'dayjs', 'YYYY-MM-DD', 'YYYYMMDD'],
  languageCode: [111, 112],
  address1: [112, 152],
  address2: [152, 192],
  city: [192, 212],
  state: [212, 214],
  zip1: [214, 219],
  zip2: [219, 223],
  phoneNumber: [223, 233],
  familyID: [233, 251],
  effectiveDate: [251, 258, parseDate, makeDate],
  terminationDate: [258, 265, parseDate, makeDate],
  altInsIndicator: [265, 266],
  medicareParticipationIndicator: [266, 267],
  medicareParticipationEventDate: [267, 275],
  hicRailroadBoardNumber: [275, 287],
  contractId: [287, 292],
  planId: [292, 295],
  esrdFromDate: [295, 302],
  esrdThruDate: [302, 309],
  dialysisFromDate: [309, 316],
  dialysisThruDate: [316, 323],
  transplantFromDate: [323, 330],
  transplantThruDate: [330, 337],
  mbrHospiceFromDate: [337, 344, parseDate, makeDate],
  mbrHospiceThruDate: [344, 351, parseDate, makeDate],
  originalEffectiveDate: [351, 358],
  disenrollmentReasonCode: [358, 359]
}

const parse = (row, oldFormat = false) => {
  row = row.toString('utf8').trim()
  if ((row.length !== 360 || row[359] !== '*') && !oldFormat) {
    throw new Error(`Error in row. Row length: ${row.length};`)
  } else if ((row.length !== 359 || row[358] !== '*') && oldFormat) {
    throw new Error(`Error in row. Row length: ${row.length};`)
  }

  let mappedRow = {}
  for (let label in DEFAULT_MAP) {
    if (!oldFormat && label === 'disenrollmentReasonCode') {
      mappedRow[label] = row.substring(DEFAULT_MAP[label][0], DEFAULT_MAP[label][1]).trim()
    } else if (oldFormat && label === 'disenrollmentReasonCode') {
      // we skip this parameter for some reason (unknown) on this old format.
      continue
    } else {
      mappedRow[label] = row.substring(DEFAULT_MAP[label][0], DEFAULT_MAP[label][1]).trim()
    }

    if (DEFAULT_MAP[label][2]) {
      if (DEFAULT_MAP[label][2] === 'dayjs') {
        mappedRow[label] = dayjs(mappedRow[label]).format(DEFAULT_MAP[label][3])
      } else if (typeof DEFAULT_MAP[label][2] === 'function') {
        mappedRow[label] = DEFAULT_MAP[label][2](mappedRow[label])
      }
    }
  }

  return mappedRow
}

/**
 *  Turn an object into an ELIG3 row format.
 *
 *  @param {Object} obj The object to be mapped to an ELIG3 row.
 *  @returns {String} The ELIG3 row.
 */
const stringify = obj => {
  let keys = Object.keys(DEFAULT_MAP)
  let str = ''
  keys.forEach(k => {
    let val = obj[k]
    if (val && typeof DEFAULT_MAP[k][2]) {
      if (DEFAULT_MAP[k][2] === 'dayjs') {
        val = dayjs(val).format(DEFAULT_MAP[k][4])
      } else if (typeof DEFAULT_MAP[k][2] === 'function') {
        val = DEFAULT_MAP[k][3](val)
      }
    }

    str += (val || '').padEnd(DEFAULT_MAP[k][1] - DEFAULT_MAP[k][0])
  })

  return str + '*'
}

module.exports = {
  parse,
  stringify,
  map: DEFAULT_MAP
}
